import { Col, Empty, Row, Spin } from "antd";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import FileCard from "../../components/FileCard";
import { getEncFileKeys } from "../../redux/action/file";
import { debugLog } from "../../utils/debugLog";
import { handleGetRequest } from "../../redux/action";
import useInfiniteScroll from "../../hooks/useInfiniteScroll"; // Import your hook
import TrashCard from "../../components/TrashCard";
import EmptyFolder from "../../components/EmptyFolder";
import { useTranslation } from "react-i18next";

const Trash = () => {
  let { t } = useTranslation();

  const fetchBinData = async ({ page, limit, isLoadMore }) => {
    try {
      const result = await handleGetRequest("/bin/v1", [], {
        loading: !isLoadMore,
        responseType: "json",
        params: {
          limit,
          page,
        },
      });

      debugLog("🚀 ~ fetchBinData ~ result:", result);
      return result;
    } catch (error) {
      debugLog("🚀 ~ fetchBinData ~ error:", "error", error);
      throw error;
    }
  };

  // Use the infinite scroll hook
  const {
    data: sub_files,
    loading,
    hasMore,
    currentPage,
    totalPages,
    error,
    loadMoreRef,
    refresh,
    isLastPage,
  } = useInfiniteScroll(fetchBinData, 1, 10);

  // Load encryption keys on component mount
  useEffect(() => {
    getEncFileKeys();
  }, []);

  return (
    <div>
      {sub_files?.length ? (
        <>
          <Row gutter={[16, 16]}>
            {sub_files.map((file, index) => {
              return (
                <Col
                  key={`${file._id}-${index}`}
                  xs={12}
                  sm={8}
                  md={6}
                  lg={4}
                  xl={4}
                  xxl={3}
                >
                  <TrashCard
                    name={file.name}
                    isSub
                    {...file}
                    icon={false}
                    directory={file.directory || ""}
                    thumbnailUrl={file.thumbnailUrl}
                    actualImage={file.originalUrl}
                    ext={file.originalFileExt}
                    isHeader
                    fileId={file._id}
                    fetchBinData={refresh}
                    fileSize={file.size}
                    fileDate={file.deletedAt}
                  />
                </Col>
              );
            })}
          </Row>

          {/* Loading indicator and scroll trigger */}
          <div
            ref={loadMoreRef}
            style={{
              textAlign: "center",
              padding: "20px",
              minHeight: "50px",
            }}
          >
            {loading && <Spin size="large" />}
          </div>
        </>
      ) : (
        <div style={{ textAlign: "center", padding: "50px" }}>
          {loading ? (
            <Spin size="large" />
          ) : (
            <EmptyFolder
              title={`${t("messages.trashEmptyTitle")}`}
              subTitle={`${t("messages.trashEmptySubtitle")}`}
            />
          )}
        </div>
      )}

      {/* Error handling */}
      {error && (
        <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
          Error loading data. Please try again.
        </div>
      )}
    </div>
  );
};

export default Trash;
